module.exports = __webpack_public_path__ + "static/media/property-people-home.04c7f62b.jpg";